var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-navbar",
        {
          attrs: { id: "header", type: "light", variant: "light", sticky: "" }
        },
        [
          _c("b-navbar-nav", [
            _c("h4", { staticClass: "mb-0" }, [_vm._v(_vm._s(_vm.title))])
          ]),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            { staticClass: "ml-auto" },
            [
              _vm.canEdit
                ? _c(
                    "b-btn",
                    {
                      attrs: {
                        size: "sm",
                        variant: "success",
                        disabled: _vm.isBusy
                      },
                      on: {
                        click: function($event) {
                          return _vm.onCreate()
                        }
                      }
                    },
                    [
                      _vm.isBusy
                        ? _c("b-spinner", { attrs: { small: "" } })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("font-awesome-icon", {
                        staticClass: "mr-1",
                        attrs: { icon: "plus" }
                      }),
                      _vm._v("\n        " + _vm._s(_vm.createText) + "\n      ")
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("filters-drawer", {
        attrs: {
          query: _vm.filters.query,
          "is-busy": _vm.isBusy,
          "hide-search-button": ""
        },
        on: {
          "update:query": function($event) {
            return _vm.$set(_vm.filters, "query", $event)
          },
          submit: _vm.onSearch
        }
      }),
      _vm._v(" "),
      _c("b-table", {
        ref: "data_table",
        staticClass: "mb-0 text-small",
        attrs: {
          id: "catalogs_tables",
          selectable: "",
          "select-mode": "single",
          selectedVariant: "success",
          striped: "",
          small: "",
          responsive: "",
          "show-empty": "",
          "empty-text": _vm.$t("message.common.emptyTable"),
          busy: _vm.isBusy,
          items: _vm.items,
          fields: _vm.fields,
          "no-provider-filtering": "",
          "no-provider-paging": "",
          "no-provider-sorting": "",
          "no-local-sorting": "",
          "sticky-header": "",
          "head-variant": "light"
        },
        on: {
          "sort-changed": _vm.sortChanged,
          "row-dblclicked": _vm.onRowClicked
        },
        scopedSlots: _vm._u(
          [
            {
              key: "table-busy",
              fn: function() {
                return [
                  _c(
                    "div",
                    { staticClass: "text-center text-success my-2" },
                    [
                      _c("b-spinner", { staticClass: "align-middle" }),
                      _vm._v(" "),
                      _c("strong", [_vm._v("Загрузка")])
                    ],
                    1
                  )
                ]
              },
              proxy: true
            },
            {
              key: "cell(name)",
              fn: function(row) {
                return [
                  _vm._t(
                    "name-tag",
                    function() {
                      return [
                        _vm._v(
                          "\n        " + _vm._s(row.item.name) + "\n      "
                        )
                      ]
                    },
                    { item: row.item }
                  )
                ]
              }
            },
            {
              key: "cell(active)",
              fn: function(row) {
                return [
                  !row.item.active
                    ? _c("font-awesome-icon", { attrs: { icon: "times" } })
                    : _vm._e(),
                  _vm._v(" "),
                  row.item.active
                    ? _c("font-awesome-icon", { attrs: { icon: "check" } })
                    : _vm._e()
                ]
              }
            },
            {
              key: "cell(action)",
              fn: function(row) {
                return [
                  _vm.canEdit
                    ? _c(
                        "b-btn",
                        {
                          attrs: { size: "sm", variant: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.onEdit(row.item)
                            }
                          }
                        },
                        [_c("font-awesome-icon", { attrs: { icon: "edit" } })],
                        1
                      )
                    : _c(
                        "b-btn",
                        {
                          attrs: { size: "sm", variant: "info" },
                          on: {
                            click: function($event) {
                              return _vm.onView(row.item)
                            }
                          }
                        },
                        [_c("font-awesome-icon", { attrs: { icon: "eye" } })],
                        1
                      )
                ]
              }
            }
          ],
          null,
          true
        )
      }),
      _vm._v(" "),
      _c("pagination-footer", {
        attrs: { "total-rows": _vm.totalRows, "per-page": _vm.perPage },
        on: {
          "update:perPage": function($event) {
            _vm.perPage = $event
          },
          "update:per-page": function($event) {
            _vm.perPage = $event
          },
          "page-click": _vm.onPagination,
          "per-page-change": _vm.onPerPageChange
        }
      }),
      _vm._v(" "),
      _c("router-view", {
        key: _vm.$route.fullPath,
        on: { refresh: _vm.getItems, "modal-closed": _vm.onModalClosed }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b9581e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b9581e2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/Catalogs.vue
// module id = null
// module chunks = 